import * as React from "react";
import IFooterProps from "./IFooter";
import FormController from "../FormController";

import LegacyFooter from "../LegacyFooter";
import TechSupportPopup from "../TechSupportPopup";

import "../../../assets/sass/components/footer.scss";

/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
class Footer extends React.Component<IFooterProps> {
    render() {
        const { isTechSupportPopUpShown } = this.props;
        return (
            <React.Fragment>
                <div className="footer-container">
                    <FormController />
                    <LegacyFooter />
                </div>
                {isTechSupportPopUpShown && (
                    <TechSupportPopup closePopup={this.props.dynamicFormActions.toggleTechSupportPopUp} />
                )}
            </React.Fragment>
        );
    }
}

export default Footer;
